import styles from "./ListTable.module.scss"

import React from "react"

interface Props {
  /** 컬럼 너비 (col width 속성, "*" 가변폭 허용) */
  colWidths: Array<number | string>
  /** 테이블 헤더 라벨 */
  headers: React.ReactNode[]
  /** 본문 <tr> 행들 */
  children: React.ReactNode
  /** 목록 영역 높이(px). 미지정 시 스타일 기본값(124px) 사용 */
  height?: number
}

export default function ListTable({
  colWidths,
  headers,
  children,
  height,
}: Props) {
  const renderColgroup = () => (
    <colgroup>
      {colWidths.map((width, i) => (
        <col key={i} width={String(width)} />
      ))}
    </colgroup>
  )

  return (
    <div
      className={`tableB ${styles.wrap}`}
      style={height ? { height } : undefined}
    >
      <div className={`inner ${styles.expand}`}>
        <table>
          {renderColgroup()}
          <thead>
            <tr>
              {headers.map((header, i) => (
                <th key={i}>{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>{children}</tbody>
        </table>
      </div>
    </div>
  )
}
